// extracted by mini-css-extract-plugin
export default {"main":"Main_main__QhrKC","active":"Main_active__aLT9V","promo":"Main_promo__Gx+4u","title":"Main_title__GogqO"};